import { render, staticRenderFns } from "./InspectionList.vue?vue&type=template&id=4779bf39&scoped=true&"
import script from "./InspectionList.vue?vue&type=script&lang=js&"
export * from "./InspectionList.vue?vue&type=script&lang=js&"
import style0 from "./InspectionList.vue?vue&type=style&index=0&id=4779bf39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4779bf39",
  null
  
)

export default component.exports